var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('section',{staticClass:"section"},[_c('div',{staticClass:"container-fluid px-0 mx-1"},[_c('h2',{staticClass:"title is-2"},[_vm._v(_vm._s(_vm.$t('title.dashboard')))]),_c('CustomerSessionTable')],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }